<template>
	<div v-if="$store.state.orderMark != {} && $store.state.orderMark.desc" class="wwim-modal">
		<form action="javascript:;">
			<p class="wm-head">修改备注<a href="javascript:;" class="close icon icon-close" @click="$store.commit('changeOrderMark', {})"></a></p>
			<div class="table ww-mark-table">
				<ul>
					<li>收货地址：</li>
					<li v-html="address(orderMark.desc)"></li>
				</ul>
				<ul>
					<li>买家留言：</li>
					<li v-html="orderMark.desc.buyer_message ? orderMark.desc.buyer_message : '暂无'"></li>
				</ul>
				<ul>
					<li>物流方式：</li>
					<li v-html="logistics(orderMark.desc.shipping_type)"></li>
				</ul>
				<ul>
					<li>标记：</li>
					<li class="wm-flag clear">
						<label class="fradio">
							<input type="radio" name="flag" v-model="orderMark.desc.seller_flag" value="0">
							<span class="wmf wmf-1"></span>
						</label>
						<label class="fradio">
							<input type="radio" name="flag" v-model="orderMark.desc.seller_flag" value="1">
							<span class="wmf wmf-2"></span>
						</label>
						<label class="fradio">
							<input type="radio" name="flag" v-model="orderMark.desc.seller_flag" value="2">
							<span class="wmf wmf-3"></span>
						</label>
						<label class="fradio">
							<input type="radio" name="flag" v-model="orderMark.desc.seller_flag" value="3">
							<span class="wmf wmf-4"></span>
						</label>
						<label class="fradio">
							<input type="radio" name="flag" v-model="orderMark.desc.seller_flag" value="4">
							<span class="wmf wmf-5"></span>
						</label>
						<label class="fradio">
							<input type="radio" name="flag" v-model="orderMark.desc.seller_flag" value="5">
							<span class="wmf wmf-6"></span>
						</label>
					</li>
				</ul>
				<ul>
					<li>备注：</li>
					<li><textarea name="memo" v-model="orderMark.desc.seller_memo"></textarea></li>
				</ul>
			</div>
			<p class="wm-btnbox">
				<input type="submit" value="确定" @click="editMark">
			</p>
		</form>
	</div>
</template>

<script>
export default {
	name: 'orderTpl',
	data () {
		return {}
	},
	computed: {
		orderMark () {
			return this.$store.state.orderMark;
		}
	},
	methods: {
		// 物流方式
		logistics (logistics) {
			var str = '';

			if (logistics == 'free') {
				str = '卖家包邮';

			} else if(logistics == 'post') {
				str = '平邮';

			} else if(logistics == 'express') {
				str = '快递';
				
			} else if(logistics == 'ems') {
				str = 'EMS';
				
			} else if(logistics == 'virtual') {
				str = '虚拟发货';
				
			}
			return str;
		},

		// 收货地址
		address (obj) {
			return obj.receiver_state + obj.receiver_city + obj.receiver_district + obj.receiver_address + ', ' + obj.receiver_name + ' ' + obj.receiver_mobile;
		},

		// 修改备注
		editMark () {
			var self = this,
				data = {
					tid: orderMark.desc.tid,
					sessionId: orderMark.desc.sessionId,
					flag: orderMark.desc.seller_flag,
					memo: orderMark.desc.seller_memo
				};

			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/updTradeMemo', data).then(result => {
				if (result.code != 200) {
					alert('修改成功');
					self.$store.commit('changeOrderMark', {});
				} else {
					alert('修改备注失败，失败原因：' + result.msg);
				}
			}, response => {
				alert('修改备注失败，失败原因：网络繁忙');
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/orderMark.vue